import styled from "@emotion/styled"
import Button from "components/Button"

export const BreadCrumbWrapper = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  height: 100%;
`

export const StyledBackButton = styled(Button)`
  height: 100%;
  border-radius: 0;
`
